import ODAS from '@/utils/api/odas';

const pluralType = (resourceType) => {
  if (resourceType.toLowerCase() === 'opportunity') return 'opportunities';
  return resourceType.toLowerCase() + 's';
};

const Note = {
  getNotes: (resourceId, resourceType) => ODAS.get(`/api/${pluralType(resourceType)}/${resourceId}/notes`),

  createNote: (noteData) => ODAS.post('/api/notes', { note: noteData }),

  updateNote: (noteId, noteData) => ODAS.put(`/api/notes/${noteId}`, { note: noteData }),

  deleteNote: (noteId) => ODAS.delete(`/api/notes/${noteId}`)
};

export default Note;
